(function () {
    'use strict';
    function main() {
        var page = wo$('#home');
        if (!page.length) return;
        var controller = {
            init: function () {
                page.find('#lead-article')
                    .off('click')
                    .click(function () {
                        var url = wo$(this).attr('data-url');
                        location.href = url;
                    });

                page.find('#popular-strip tr.hover-bg').click(function () {
                    var url = wo$(this).find('a').attr('href');
                    if (url) {
                        location.href = url;
                    }
                });

                WhistleOut.getAds('Broadband');
            }
        };
        controller.init();
    }

    WhistleOut.initModule(import.meta.url, main);
})();
